import {
  Field,
  FieldType,
  FieldGroup,
  OutputArrayTypes,
} from "@/core/types/types";

/** This reducer callback is served to re-arrange components array,
 * and encapsulate / combine sibling Buttons into a separate array,
 * e.g. ['text', 'date', { 'group': ['text', 'input'] }, ...] or
 * ['text', 'date', { 'navigation': ['next', 'back'] }, ...], that'll be
 * later handled by NavigationButtons or other component,
 * which will be responsible for proper alignment in the markup and styling.
 * This function  returns array of Fields + nested array with Fields.
 *
 * @param {Array} acc - accumulator array
 * @param {Field} currentField - Current field in components array
 * @returns {Field[] & FieldGroup[]} - Rearranged Field array
 */
const componentsManager = (
  acc: (Field | FieldGroup)[],
  currentField: Field
): (Field | FieldGroup)[] => {
  const lastIndex: number = acc.length - 1;
  let lastItem: Field | FieldGroup = acc[lastIndex];

  const pushToProperty = (property: OutputArrayTypes, field: Field): void => {
    // Push the object with property name and empty array
    if (!lastItem || !(property in lastItem)) {
      lastItem = { [property]: [] };
      acc.push(lastItem);
    }
    // Fill the array with the field
    if (Array.isArray((lastItem as FieldGroup)[property])) {
      const lastGroup: Field[] | undefined = (lastItem as FieldGroup)[property];
      lastGroup && lastGroup.push(field);
    }
  };

  if (currentField.properties?.group) {
    pushToProperty(OutputArrayTypes.FieldGroup, currentField);
  } else if (currentField.type === FieldType.Button) {
    //todo change the Navigation group definition from the 'Button' field type to 'group' property
    pushToProperty(OutputArrayTypes.Navigation, currentField);
  } else {
    acc.push(currentField);
  }

  return acc;
};

export default componentsManager;
